import { Terminal } from './Terminal';
import { TimeZone } from './TimeZone';
import { Country } from './Country';
import { IPropertyEntity } from './IPropertyEntity';

export class Port implements IPropertyEntity {
    constructor(
        portId: number,
        portName: string,
        portClusterName: string,
        country: Country | null,
        terminalArray: Terminal[],
        timeZoneArray: TimeZone[],
        isEuMrvPort: boolean
    ) {
        this.portId = portId;
        this.portName = portName;
        this.portClusterName = portClusterName;
        this.country = country;
        this.terminalArray = terminalArray;
        this.timeZoneArray = timeZoneArray ? timeZoneArray : [];
        this.isEuMrvPort = isEuMrvPort;
        this.pKPortId = portId;
        this.pKBerthId = 0;
        this.pKTerminalId = 0;
        this.pKBerthRestrictionId = 0;
        this.changedBy = '';
        this.deltaInSecondsOnMachine = 0;
    }
    portId: number;
    portName: string;
    portClusterName: string;
    country: Country | null;
    terminalArray: Terminal[];
    timeZoneArray: TimeZone[];
    deltaInSecondsOnMachine: number;
    isEuMrvPort: boolean;
    pKPortId: number;
    pKBerthId: number;
    pKTerminalId: number;
    pKBerthRestrictionId: number;
    changedBy: string;
}
